import settings from "@settings";
import { css } from "@emotion/react";

export const priceContainer = css({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    padding: settings.padding.small,
    borderRadius: settings.borderRadius.medium,
    backgroundColor:settings.colors.white,
    boxShadow: settings.shadows.regular,
    border: `1px solid ${settings.colors.grey}`,
    'h3': {
        marginTop: settings.sizes.medium,
    }
})

export const priceCostContainer = css({
    paddingTop: settings.sizes.medium,
    paddingBottom: settings.sizes.medium,  
    borderBottom: `1px solid ${settings.colors.grey}`,
    borderTop: `1px solid ${settings.colors.grey}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center', 
    justifyContent: 'flex-start',
    gap: settings.sizes.small,
})

export const featuresContainer = css({
    marginTop: settings.sizes.medium,
    marginBottom: settings.sizes.medium,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: settings.sizes.medium,
})

export const featureContainer = css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start ',
    gap: settings.sizes.medium,
    'h5' : {
        margin: 0
    }
})

export const priceValue = css({
    fontSize: settings.fontSize.large,
    fontWeight: 700
})